export default {
  methods: {
    getOrganizationStatus(status) {
      const mappedStatus = {
        default: {
          text: this.$t("leads.details.organization.statuses.null"),
          icon: "help_outline",
          color: "grey lighten-1",
          textColor: "grey--text text--lighten-1"
        },
        pending: {
          text: this.$t("leads.details.organization.statuses.pending"),
          icon: "hourglass_empty",
          color: "orange lighten-1",
          textColor: "orange--text text--lighten-1"
        },
        active: {
          text: this.$t("leads.details.organization.statuses.active"),
          icon: "check_circle",
          color: "green accent-2",
          textColor: "green--text text--accent-2"
        },
        past_due: {
          text: this.$t("leads.details.organization.statuses.past_due"),
          icon: "error_outline",
          color: "red lighten-1",
          textColor: "red--text text--lighten-1"
        },
        suspended: {
          text: this.$t("leads.details.organization.statuses.suspended"),
          icon: "pause_circle_filled",
          color: "blue-grey darken-1",
          textColor: "blue-grey--text text--darken-1"
        },
        canceled: {
          text: this.$t("leads.details.organization.statuses.canceled"),
          icon: "cancel",
          color: "red accent-2",
          textColor: "red--text text--accent-2"
        },
        deleted: {
          text: this.$t("leads.details.organization.statuses.deleted"),
          icon: "delete_forever",
          color: "grey darken-2",
          textColor: "grey--text text--darken-2"
        },
        internal: {
          text: this.$t("leads.details.organization.statuses.internal"),
          icon: "lock",
          color: "blue darken-2",
          textColor: "blue--text text--darken-2"
        }
      };

      return mappedStatus[status.toLowerCase()] || mappedStatus.default;
    }
  }
};
